import { DateRangeContext } from "../../store/DashboardDateRangeContext";
import DomainDetailModal from "../Centralized/DomainDetailModal";
import AggrementDomainListModal from "./AggrementDomainListModal";
import CurrentMonthMemberModal from "./CurrentMonthMemberModal";
import SegmentDomainListModal from "./SegmentDomainListModal";
import FlagsDomainListModal from "./FlagsDomainListModal";
import CurrentDataModal from "./CurrentDataModal";
import DomainListModal from "../DomainListModal";
import { useState, useContext } from "react";
import Div from "../Div";
import DailyDashboard from "./DailyDashboard";

export default function RenewalTeam({ title, data, columns, selectedMonth, tag }) {

    const [teamDomainListModal, setTeamDomainListModal] = useState(false);
    const [segmentDomainListModal, setSegmentDomainListModal] = useState(false);
    const [aggrementDomainListModal, setAggrementDomainListModal] = useState(false);
    const [flagsDomainListModal, setFlagsDomainListModal] = useState(false);
    const [currentDataModal, setCurrentDataModal] = useState(false);
    const [centralized, setCentralized] = useState(false);
    const [reseller, setReseller] = useState(false);
    const [member, setMember] = useState(false);

    const month = useContext(DateRangeContext);

    function handleTeamDomainClick(dataValue, tagType) {
        // Logic for both Monthly Team and Today's Grouped widget
        if (tagType === 'team' || tagType === 'today') {
            const admin = {
                admin_email: dataValue, // Member email (or 'Unassigned')
                // Crucial: send 'today' flag or the actual month string
                month: tagType === 'today' ? 'today' : selectedMonth 
            };
            setTeamDomainListModal(admin);
        }

        if (tagType === 'segments') { setSegmentDomainListModal(dataValue); }
        if (tagType === 'aggrements') { setAggrementDomainListModal(dataValue); }
        if (tagType === 'flags') { setFlagsDomainListModal(dataValue); }
        if (tagType === 'current') { setCurrentDataModal(dataValue); }
        if (tagType === 'centralized') { setCentralized(dataValue); }
        if (tagType === 'member') { setMember(dataValue); }
        if (tagType === 'reseller_member') { setReseller(dataValue); }
    }

    return (
        <>
            {teamDomainListModal && (
                <DomainListModal 
                    show={true.toString()} 
                    open 
                    admin={teamDomainListModal}
                    handleClicked={setTeamDomainListModal} 
                />
            )}

            {segmentDomainListModal && (
                <SegmentDomainListModal 
                    show={true.toString()} 
                    open
                    segment={segmentDomainListModal.data} 
                    month={month} 
                    handleClicked={setSegmentDomainListModal} 
                />
            )}

            {aggrementDomainListModal && (
                <AggrementDomainListModal 
                    show={true.toString()} 
                    open
                    aggrement={aggrementDomainListModal} 
                    handleClicked={setAggrementDomainListModal} 
                />
            )}

            {flagsDomainListModal && (
                <FlagsDomainListModal 
                    show={true.toString()} 
                    open
                    flags={flagsDomainListModal} 
                    handleClicked={setFlagsDomainListModal} 
                />
            )}

            {currentDataModal && (
                <CurrentDataModal 
                    show={true.toString()} 
                    open
                    flags={currentDataModal} 
                    handleClicked={setCurrentDataModal} 
                />
            )}

            {centralized && (
                <DomainDetailModal 
                    show={true.toString()} 
                    open
                    domain_name={centralized} 
                    handleClicked={setCentralized} 
                />
            )}

            {member && (
                <CurrentMonthMemberModal 
                    show={true.toString()} 
                    open
                    flags={member} 
                    handleClicked={setMember} 
                />
            )}

            <label style={{ marginLeft: '25%' }}><strong>{title}</strong></label>
            <Div
                className="table-responsive mdc-data-table--sticky-header"
                style={{ maxHeight: "375px", overflowY: "auto", scrollbarWidth: "thin" }}
            >
                <table className="table table-hover sticky-header">
                    <thead>
                        <tr>{columns}</tr>
                    </thead>
                    <tbody>
                        {data ? data.map((domain, index) => (
                            <tr key={index}>
                                {tag === 'extensions' ? (
                                    <>
                                        <td>{domain.customerDomain}</td>
                                        <td className="fw-bold text-danger">{domain.extension_date}</td>
                                    </>
                                ) : tag === 'today' ? (
                                    <>
                                        <td style={{ fontSize: '13px' }}>
                                            {domain.assigned_to || 'Unassigned'}
                                        </td>
                                        <td style={{ fontSize: '13px' }}>
                                            <button
                                                onClick={() => handleTeamDomainClick(domain.assigned_to || 'Unassigned', 'today')}
                                                className="btn btn-link p-0"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                {domain.domain_count}
                                            </button>
                                        </td>
                                    </>
                                ) : tag === 'team' ? (
                                    <>
                                        <td style={{ fontSize: '13px' }}>
                                            {domain.assigned_to || 'Unassigned'}
                                        </td>
                                        <td style={{ fontSize: '13px' }}>
                                            <button
                                                onClick={() => handleTeamDomainClick(domain.assigned_to || 'Unassigned', 'team')}
                                                className="btn btn-link p-0"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                {domain.total_count}
                                            </button>
                                        </td>
                                    </>
                                ) : (
                                    <>
                                        <td>{Object.values(domain)[0]}</td>
                                        <td>
                                            <button 
                                                onClick={() => handleTeamDomainClick(Object.values(domain)[0], tag)} 
                                                className="btn btn-link p-0"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                {Object.values(domain)[1]}
                                            </button>
                                        </td>
                                    </>
                                )}
                            </tr>
                        )) : null}
                    </tbody>
                </table>
            </Div>
        </>
    );
}